import React, { Component } from 'react';
import CloudServiceItem from './CloudServiceItem';

class CloudService extends Component{
    render(){
        return(
            <section className="software_featured_area">
                <div className="container">
                    <h2 className="f_600 f_size_30 t_color3 text-center l_height40 mb_70 wow fadeInUp" data-wow-delay="0.3s">We are the leading manufacturer of spring hangers, supports & accessories. Over the past 36 years we have supplied to major power plants, refineries, nuclear installations & process industries in India & several International projects.</h2>
                    <div className="row software_featured_info">
                        <CloudServiceItem colWidth="4" icon="icon1.png" sTitle="ISO Certified International Standards" Sp=""/>
                        <CloudServiceItem colWidth="4" icon="icon2.png" sTitle="State Of The Art Global Manufacturing Facilities" Sp=""/>
                        <CloudServiceItem colWidth="4" icon="icon3.png" sTitle="Highest Safety Standards" Sp=""/>
                        </div>
                        <div className="row text-center mx-auto software_featured_info">
                        <CloudServiceItem colWidth="6" icon="icon4.png" sTitle="We Meet A Wide Range Of Fabrication Requirements" Sp=""/>
                        <CloudServiceItem colWidth="6" icon="icon5.png" sTitle="Engineering Design & Solutions" Sp=""/>
                        </div>
                    </div>
            </section>
        )
    }
}
export default CloudService;